// extracted by mini-css-extract-plugin
export var childrenContainer = "_ce-0";
export var virtualScrollArea = "_ce-1";